import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';
import { LoadingState } from '@/components/StateMessage/StateMessage';

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, authLevel, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingState />;
  if (!user) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  }
  if (!user.totpEnabled || authLevel !== 'full') {
    return <Navigate to="/2fa/setup" replace state={{ from: location.pathname }} />;
  }
  return children;
}
